/**
 * Integrations page — localization manifest.
 */
export const integrationsManifest: readonly string[] = [
  "integrations.title",
  "integrations.connected",
  "integrations.disconnected",
  "integrations.connect",
  "integrations.disconnect",
  "integrations.sync",
  "integrations.lastSync",
  "integrations.health",
  // Shared
  "nav.integrations",
  "common.loading",
  "common.noData",
  "common.search",
  "common.filter",
  "common.actions",
  "common.status",
] as const;
